<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title_flex">
        <div class="componentSty_content_title">
        <span class="fonints">产品</span>
        <el-input
          placeholder="请输入关键词"
          v-model="selectitem.name"
          clearable
        >
        </el-input>
        <span class="fonints">平台</span>
         <el-input
          placeholder="请输入关键词"
          v-model="selectitem.platform"
          clearable
        >
        </el-input>
        <span class="fonints">状态</span>
        <el-radio v-model="selectitem.status" :label="1">无效</el-radio>
        <el-radio v-model="selectitem.status" :label="2">有效</el-radio>
        
      </div>
        <div class="componentSty_content_title_flex_button">
          <button class="buttons" @click="selectlist">查询</button>
          <button class="buttons" @click="editmsg({},'/app/version/save')" style="background:#33e38c">新增</button>
        </div>
      </div>
      
      <div class="componentSty_content_table" style="border:none">
        <el-table :data="arrlist.list" border style="width: 100%; height: 80%"  height="80%">
           <el-table-column show-overflow-tooltip :render-header="renderHeader"
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="name" label="产品"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="platform" label="平台"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="version" label="版本号"> </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="版本状态">
            <template v-slot="res">
              <span v-if="res.row.status == 1" style="color: rgb(254, 90, 36)">
                无效
              </span>
              <span v-if="res.row.status == 2" style="color: rgb(19, 209, 104)">
                有效
              </span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="强制更新">
            <template v-slot="res">
              <span v-if="res.row.isForce == 1" style="color: rgb(254, 90, 36)">
                否
              </span>
              <span
                v-if="res.row.isForce == 2"
                style="color: rgb(19, 209, 104)"
              >
                是
              </span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="note" label="更新描述"></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="peopleCreate" label="创建者"></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="创建时间">
            <template v-slot="res">
              {{ mydateFormat(res.row.gmtCreate, "时分秒") }}
            </template>
          </el-table-column>
            <el-table-column show-overflow-tooltip :render-header="renderHeader" prop="url" label="地址"></el-table-column>
          <el-table-column show-overflow-tooltip :render-header="renderHeader" label="操作">
            <template v-slot="res">
              <span style="cursor: pointer" @click="editmsg(res.row,'/app/version/update')">
                编辑
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.list&&arrlist.list.length">
          <el-pagination
            v-if="arrlist.totalCount"
            :page-size="selectitem.limit"
             layout="total,prev, pager,next, jumper"
            :total="arrlist.totalCount"
            :current-page="selectitem.page"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
        <m-dialog :isShow="dialogisshow" @changeState="changeState" title="">
          <div class="inForMsgBox">
            <div class="itemBox" style="width: 100%">
              <span class="key" style="width:21%">产品</span>
              <div class="val">
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{ editobj.name
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <div class="menu_box">
                      <el-dropdown-item
                      v-for="item in dropdownlist"
                      :key="item.id"
                      :command="item"
                      >{{ item.val }}</el-dropdown-item
                    >
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div class="itemBox" style="width: 100%">
              <span class="key" style="width:21%">平台</span>
              <div class="val">
                <el-radio v-model="editobj.platform" :label="'Android'">Android</el-radio>
                <el-radio v-model="editobj.platform" :label="'IOS'">IOS</el-radio>
              </div>
            </div>
            <div class="itemBox" style="width: 100%">
              <span class="key" style="width:21%">版本号</span>
              <div class="val">
                <input class="inputs" type="text" v-model="editobj.version" />
              </div>
            </div>
            <div class="itemBox" style="width: 100%">
              <span class="key" style="width:21%">版本状态</span>
              <div class="val">
                <el-radio v-model="editobj.status" :label="1">无效</el-radio>
                <el-radio v-model="editobj.status" :label="2">有效</el-radio>
              </div>
            </div>
            <div class="itemBox" style="width: 100%">
              <span class="key" style="width:21%">强制更新</span>
              <div class="val">
                <el-radio v-model="editobj.isForce" :label="1">否</el-radio>
                <el-radio v-model="editobj.isForce" :label="2">是</el-radio>
              </div>
            </div>
            <div class="itemBox" style="width: 100%">
              <span class="key" style="width:21%">更新描述</span>
              <div class="val">
                <input class="inputs" type="text" v-model="editobj.note" />
              </div>
            </div>
               <div class="itemBox" style="width: 100%">
              <span class="key" style="width:21%">地址</span>
              <div class="val">
                <input class="inputs" type="text" v-model="editobj.url" />
              </div>
            </div>
          </div>
        </m-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import { antiShake } from "@/plugins/other.js";
import mDialog from "@/components/mDialog";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{ name: "运维管理" }, { name: "版本管理" }],
      selectitem: {},
      dropdownlist: [],
      dialogisshow: false,
      editobj: {
        id: "",
        name: "",
        appid: "",
        platform: "",
        version: "",
        status: null,
        isForce: null,
        note: null,
        url:null,
      },
      arrlist: {},
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
  },
  components: {
    mTitle,
    mDialog,
  },
  created() {
    this.conditionsList[this.$route.path] ||
      this.createConditions({ key: this.$route.path,val:{
        page: 1, //当前页码
        limit: 20, //每页显示条数
        status: 2,
      } });
    this.selectitem = this.conditionsList[this.$route.path] || {
        page: 1, //当前页码
        limit: 20, //每页显示条数
        status: 2,
      };
    this.getarrlist();
  },
  methods: {
    ...mapMutations(["createConditions"]),
    async getarrlist() {
      const { data } = await this.$http(
        "api1",
        "/app/version/list",
        "get",
        this.selectitem
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.arrlist = data.data;
    },
    itemparticulars(res) {
      window.sessionStorage.setItem("infoid", res.id);
      this.$router.push({ name: "particulars" });
    },
    async checkState(row) {
      if (row.fleetStatus == 3) {
        row.fleetStatus = 1;
        const { data } = await this.$http(
          "api1",
          "/fleet/fleetfleetmessage/fleetInitiateMode",
          "post",
          { ids: [row.id] }
        );
        if (!data || data.msg != "success")
          return this.$message.error("修改失败");
        this.$message.success("启用成功");
      } else {
        row.fleetStatus = 3;
        const { data } = await this.$http(
          "api1",
          "/fleet/fleetfleetmessage/fleetDeadStatus",
          "post",
          { ids: [row.id] }
        );
        if (!data || data.msg != "success")
          return this.$message.error("修改失败");
        this.$message.success("停用成功");
      }
    },

    async changeState(event) {
      if (event === "close") return (this.dialogisshow = false);
      const { data } = await this.$http(
        "api1",
        this.api,
        "post",
        this.editobj
      );
      if (data.code != 0) return this.$message.error(data.msg);
      this.api=="/app/version/save"?this.$message.success("新增成功"):this.$message.success("修改成功");
      this.dialogisshow = false;
      this.getarrlist();
    },
    async editmsg(row,api) {
      this.api=api;
      const { data } = await this.$http("api1", "/sys/dic/list", "get", {
        dictionaryType: "产品标识",
      });
      if (data.code != 0) return this.$message.error(data.msg);
      this.dropdownlist = data.data;
      this.dialogisshow = true;
      for (let i in this.editobj) {
        this.editobj[i] = row[i]||null;
      }
      if(!this.editobj.name){
        this.editobj.name=data.data[0].val;
        this.editobj.appid=data.data[0].mark
      }
    },
    handleCommand(event) {
      this.editobj.name = event.val;
      this.editobj.appid = event.mark;
    },
    selectlist() {
      antiShake((_) => {
        this.selectitem.page = 1;
        this.getarrlist();
      });
    },
    handleCurrentChange(index) {
      if (this.arrlist.totalCount < this.selectitem.limit) return;
      this.selectitem.page = index;
      this.getarrlist();
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
